<template>
  <div>
    <p>No Material Object Loaded</p>
  </div>
</template>

<script>
export default {};
</script>

<style>
.Vue-Toastification__toast-component-body p {
  margin: 0;
}
</style>
